export default {"src":"/_next/static/media/signature.e2c675c4.svg","height":34,"width":154,"blurWidth":0,"blurHeight":0};